import {JOB_STATUSES} from "../../services/ConstantService";
import {UrlService} from "../../services/UrlService";
import {GlobalService} from "../../services/GlobalService";

const state={
  jobStatuses:{}
}

const mutations={

  SET_JOB_STATUSES : (state,status) => state.jobStatuses=status

}

const actions = {

  async getJobStatuses({commit},payload = null){
    const uri = [JOB_STATUSES].join('/');
    const queryString= payload ? UrlService.setQueryString(payload) : '';
    const response  = await GlobalService.ajax('get',uri+queryString,{});
    if(response.status == 200) {
      commit('SET_JOB_STATUSES',response.data);
      return true;
    }
    return false;
  }

}

const getters = {
  jobStatuses: (state)=>state.jobStatuses
}


export default { state,mutations,actions,getters }
